import { Box, Button, ButtonGroup, Flex, Text } from "@chakra-ui/react";
import i18next from "i18next";
import { Dispatch, SetStateAction } from "react";

interface Props {
  title: string;
  showRange: boolean;
  setShowRange: Dispatch<SetStateAction<boolean>>;
}
export const ScoreFilterHeader: React.FC<Props> = ({
  title,
  showRange,
  setShowRange,
}) => {
  return (
    <Flex alignItems="center" mt={2}>
      <Text>{title}</Text>
      <Box flexGrow={1} />
      <ButtonGroup attached size="sm">
        <Button
          onClick={() => setShowRange(true)}
          variant={showRange ? "solid" : "subtle"}
          colorPalette={"primary"}
        >
          {i18next.t("map:filters.score.byNumber")}
        </Button>
        <Button
          onClick={() => setShowRange(false)}
          variant={!showRange ? "solid" : "subtle"}
          colorPalette={"primary"}
        >
          {i18next.t("map:filters.score.byColor")}
        </Button>
      </ButtonGroup>
    </Flex>
  );
};
